/* ==========================================================================
   Product redesign — dynamic delivery estimate + scroll arrows for the
   Encadrement / Dimension box-selector rows.
   ========================================================================== */
(function () {
  'use strict';

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function formatDateEN(date) {
    return pad2(date.getDate()) + '/' + pad2(date.getMonth() + 1);
  }

  function renderDeliveryEstimates(root) {
    var nodes = (root || document).querySelectorAll('.js-reinsurance-shipping-text');
    if (!nodes.length) return;

    nodes.forEach(function (node) {
      var min = parseInt(node.getAttribute('data-lead-min'), 10);
      var max = parseInt(node.getAttribute('data-lead-max'), 10);
      if (isNaN(min)) min = 21;
      if (isNaN(max)) max = 25;

      var today = new Date();
      var from = new Date(today);
      from.setDate(from.getDate() + min);
      var to = new Date(today);
      to.setDate(to.getDate() + max);

      node.textContent = 'delivered between ' + formatDateEN(from) + ' and ' + formatDateEN(to);
    });
  }

  /* --- Scroll arrows for the box-selector content rows --------------------- */
  function setupScrollArrows(root) {
    var contents = (root || document).querySelectorAll('.box-selector-content');

    contents.forEach(function (content) {
      var container = content.querySelector('.product__option-container');
      var prevBtn = content.querySelector('.box-selector-arrow-left');
      var nextBtn = content.querySelector('.box-selector-arrow-right');
      if (!container || !prevBtn || !nextBtn) return;
      if (content.dataset.scrollArrowsReady === 'true') return;
      content.dataset.scrollArrowsReady = 'true';

      function scrollByAmount(direction) {
        var amount = container.clientWidth * 0.7;
        container.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', function () {
        scrollByAmount(-1);
      });
      nextBtn.addEventListener('click', function () {
        scrollByAmount(1);
      });

      function updateArrowState() {
        var maxScroll = container.scrollWidth - container.clientWidth;
        prevBtn.disabled = container.scrollLeft <= 1 || maxScroll <= 1;
        nextBtn.disabled = container.scrollLeft >= maxScroll - 1 || maxScroll <= 1;
      }

      container.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      updateArrowState();

      /* Images (corner-preview / variant photos) inside the row can still be
         loading when this first runs, so scrollWidth is momentarily wrong and
         the arrows get stuck "disabled". Re-check once everything has
         actually loaded and whenever the row's own size changes. */
      var images = container.querySelectorAll('img');
      images.forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', updateArrowState, { once: true });
        }
      });

      window.addEventListener('load', updateArrowState);
      setTimeout(updateArrowState, 300);
      setTimeout(updateArrowState, 1000);

      if (typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(function () {
          updateArrowState();
        });
        resizeObserver.observe(container);
      }
    });
  }

  /* --- Live label next to the option title + total-dimension line ---------- */
  function setupInteractiveLabels(root) {
    var fieldsets = (root || document).querySelectorAll('.product-sheet-box-selector');

    fieldsets.forEach(function (fieldset) {
      if (fieldset.dataset.interactiveLabelReady === 'true') return;
      fieldset.dataset.interactiveLabelReady = 'true';

      fieldset.addEventListener('change', function (event) {
        var input = event.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio' || !input.checked) return;

        var nameEl = fieldset.querySelector('[data-box-selector-name]');
        if (nameEl) {
          nameEl.textContent = input.value;
        }

        var dimensionEl = fieldset.querySelector('[data-total-dimension]');
        if (dimensionEl) {
          var match = input.value.match(/\(([^)]+)\)/);
          if (match) {
            var raw = match[1].replace(/cm/gi, '').trim();
            dimensionEl.textContent = raw.replace(/x/gi, ' x ') + ' cm';
          }
        }

        /* Smoothly glide the row so the newly-picked swatch is centered,
           instead of leaving it wherever it happened to be scrolled. */
        var container = fieldset.querySelector('.product__option-container');
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (container && label) {
          var targetLeft = label.offsetLeft - (container.clientWidth - label.offsetWidth) / 2;
          var maxScroll = container.scrollWidth - container.clientWidth;
          targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));
          container.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  function init(root) {
    renderDeliveryEstimates(root);
    setupScrollArrows(root);
    setupInteractiveLabels(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  /* Re-run when Shopify sections are re-rendered (theme editor, variant swap) */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    init(document);
  }
})();
